/*! Contains data derived from Unicode CLDR 48.2.
 * Copyright (c) 1991-2025 Unicode, Inc. All rights reserved.
 * Distributed under the Terms of Use in https://www.unicode.org/copyright.html
 * SPDX-License-Identifier: Unicode-3.0
 * The full licence text is THIRD-PARTY-NOTICES.md in this package.
 */
// Generated by tools/gen-data.js from pinned CLDR 48.2. Do not edit by hand.
// Source: lokalized-spec vendor/lokalized-java (cldr-locale-data.rightToLeftScripts).
/** @type {string[]} */
const S = ["Adlm","Arab","Armi","Avst","Chrs","Cprt","Elym","Gara","Hatr","Hebr","Hung","Khar","Lydi","Mand","Mani","Mend","Merc","Mero","Narb","Nbat","Nkoo","Orkh","Ougr","Palm","Phli","Phlp","Phnx","Prti","Rohg","Samr","Sarb","Sidt","Sogd","Sogo","Syrc","Thaa","Yezi"];
/** @returns {string[]} */
export const decode = () => S.slice();
